exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".box-upper{padding:18px;border-bottom:1px solid #eee}.box-upper .tab-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:8px}.box-upper .tab-wrapper .tab-item{border-radius:50px;padding:6px 14px;border:1px solid #ddd;background-color:#fff;color:#363636;text-align:center;font-size:14px;line-height:22px}.box-upper .tab-wrapper .selected{background-color:#363636;border:1px solid #363636;color:#fff}", ""]);

// exports
